<form class="d-flex flex-wrap align-items-center gap-2"
	  [formGroup]="componentForm"
	  (ngSubmit)="search()"
	  #barcodeForm="ngForm"
	  [attr.data-test-id]="'barcodeComponent'">
	@if (componentForm.invalid && barcodeForm.submitted) {
		<gandalf-lib-validation-messages
			[form]="componentForm"
			[requestObj]="barcodeSearchRequest"
			[attr.data-test-id]="'barcodeComponentValidationMessages'">
		</gandalf-lib-validation-messages>
	}
	<div class="row mb-3">
		@if (label) {
			<label>{{ label }}</label>
		}
		<input
			[revFocusInput]="focusInput"
			formControlName="barcodeValue"
			class="e-input"/>
		<button ejs-button type="submit" cssClass="e-success margin-left-sm">{{ buttonLabel }}</button>
	</div>
</form>
